import { type FC } from 'react';
import { IconButton } from '@chakra-ui/react';
import cx from 'classnames';
import { ReactComponent as PlayIcon } from '../../../assets/svg/PlayIconWhite.svg';
import { ReactComponent as PauseIcon } from '../../../assets/svg/PauseIconWhite.svg';
import { useAppInsights } from '../../../hooks/useAppInsights';
import { Event, type VesselViewModel } from '../../../types';
import { getEventFactory } from '../../../utils/get-event-factory';
import { type Timestamp } from '../../../services/Timestamp';
import { translate } from '../../../constants/translation';

interface Props {
  isPlaying: boolean;
  setIsPlaying: (isPlaying: boolean) => void;
  vessel: VesselViewModel;
  timestamp: Timestamp;
}

const PlayButton: FC<Props> = ({ isPlaying, setIsPlaying, vessel, timestamp }) => {
  const appInsights = useAppInsights();

  const togglePlay = (): void => {
    setIsPlaying(!isPlaying);
    const eventType = isPlaying ? Event.PlaybackPaused : Event.PlaybackStarted;
    const event = getEventFactory(eventType)(vessel?.mmsi, window.location.href, timestamp);
    appInsights.trackAnalyticsEvent(event);
  };

  return (
    <div>
      <IconButton
        aria-label={translate('PLAY')}
        icon={isPlaying ? <PauseIcon /> : <PlayIcon />}
        className={cx('play-button', { playing: isPlaying })}
        onClick={togglePlay}
      />
    </div>
  );
};

export default PlayButton;
